/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* Components */
import HeroOverlay from './components/HeroOverlay';

/* utilities */
import { parseDataToProps } from '~/utilities';

const productGridNodes = Array.from(document.querySelectorAll('.hero-overlay'));
[...productGridNodes].forEach((node) => render(<HeroOverlay {...parseDataToProps(node.dataset)} />, node));
